import React, { useEffect } from "react";
import { MultiSelect } from "primereact/multiselect";

export default function SelectStore({
  storesFetched,
  selectedStores,
  onSelectionChange,
}: any) {
  const [data, setData] = React.useState([]);

  const handleSelected = (e: any) => {
    onSelectionChange(e.target.value);
  };

  useEffect(() => {
    const userOptions = storesFetched?.map((item: any) => {
      return {
        name: item.name,
        value: item._id,
      };
    });

    setData(userOptions);

    // eslint-disable-next-line
  }, [storesFetched]);

  return (
    <div className="w-full manage-store-multiselect">
      <MultiSelect
        value={selectedStores}
        onChange={handleSelected}
        options={data}
        optionLabel="name"
        filter
        placeholder="Select Stores"
        maxSelectedLabels={3}
        virtualScrollerOptions={{ itemSize: 42 }}
        resetFilterOnHide={true}
        display="chip"
        className="
          w-full
          rounded-sm
          border
          border-[rgb(var(--border-primary))]
          bg-[rgb(var(--surface-2))]
          text-[rgb(var(--text-primary))]
          shadow-none
          transition-all
          duration-300
          hover:border-[rgba(212,168,74,0.25)]
          focus-within:border-[rgba(212,168,74,0.35)]
          focus-within:ring-0
        "
        panelClassName="manage-store-multiselect-panel"
      />

      <style>
        {`
          /* ===================================================
             MAIN INPUT
          =================================================== */

          .manage-store-multiselect .p-multiselect {
            height: 38px;
            border-radius: 6px;
            background: rgb(var(--surface-2));
            border: 1px solid rgb(var(--border-primary));
            transition: all 0.3s ease;
            box-shadow: none !important;
          }

          .manage-store-multiselect .p-multiselect:hover {
            border-color: rgba(var(--color-gold-1), 0.25);
          }

          .manage-store-multiselect .p-multiselect:not(.p-disabled).p-focus {
            border-color: rgba(var(--color-gold-1), 0.4);
            box-shadow:
              0 0 0 4px rgba(var(--color-gold-1), 0.08) !important;
          }

          /* ===================================================
             LABEL / PLACEHOLDER
          =================================================== */

          .manage-store-multiselect .p-multiselect-label {
            padding: 12px 14px;
            font-size: 13px;
            font-weight: 400;
            color: rgb(var(--text-primary));
          }

          .manage-store-multiselect
            .p-multiselect-label.p-placeholder {
            color: rgb(var(--text-muted));
          }

          /* ===================================================
             DROPDOWN ICON
          =================================================== */

          .manage-store-multiselect .p-multiselect-trigger {
            width: 42px;
            color: rgb(var(--text-secondary));
          }

          /* ===================================================
             CHIPS
          =================================================== */

          .manage-store-multiselect .p-multiselect-token {
            background:
              rgba(var(--color-gold-1), 0.12);
            color:
              rgb(var(--color-gold-1));

            border:
              1px solid rgba(var(--color-gold-1), 0.18);

            border-radius: 999px;

            padding: 6px 10px;

            font-size: 11px;
            font-weight: 600;
            letter-spacing: 0.04em;

            margin-right: 6px;
          }

          .manage-store-multiselect
            .p-multiselect-token-icon {
            color: rgb(var(--color-gold-1));
            width: 12px;
            height: 12px;
          }

          /* ===================================================
             PANEL
          =================================================== */

          .manage-store-multiselect-panel {
            margin-top: 10px;
            overflow: hidden;

            border-radius: 24px !important;

            border:
              1px solid rgb(var(--border-primary)) !important;

            background:
              rgb(var(--surface-1)) !important;

            box-shadow:
              var(--shadow-card-hover) !important;

            backdrop-filter: blur(14px);
          }

          /* ===================================================
             HEADER
          =================================================== */

          .manage-store-multiselect-panel
            .p-multiselect-header {
            padding: 14px;
            border-bottom:
              1px solid rgb(var(--border-primary));

            background:
              rgb(var(--surface-2));
          }

          /* ===================================================
             SEARCH INPUT
          =================================================== */

          .manage-store-multiselect-panel
            .p-inputtext {
            width: 100%;

            height: 42px;

            border-radius: 14px;

            border:
              1px solid rgb(var(--border-primary));

            background:
              rgb(var(--surface-1));

            color:
              rgb(var(--text-primary));

            font-size: 13px;

            box-shadow: none !important;
          }

          .manage-store-multiselect-panel
            .p-inputtext:focus {
            border-color:
              rgba(var(--color-gold-1), 0.35);

            box-shadow:
              0 0 0 3px rgba(var(--color-gold-1), 0.08) !important;
          }

          /* ===================================================
             ITEMS
          =================================================== */

          .manage-store-multiselect-panel
            .p-multiselect-items {
            padding: 10px;
          }

          .manage-store-multiselect-panel
            .p-multiselect-item {
            border-radius: 14px;

            padding: 12px 14px;

            margin-bottom: 4px;

            color:
              rgb(var(--text-primary));

            font-size: 13px;

            transition: all 0.25s ease;
          }

          .manage-store-multiselect-panel
            .p-multiselect-item:hover {
            background:
              rgba(var(--color-gold-1), 0.08);
          }

          .manage-store-multiselect-panel
            .p-multiselect-item.p-highlight {
            background:
              rgba(var(--color-gold-1), 0.12);

            color:
              rgb(var(--color-gold-1));

            font-weight: 500;
          }

          .p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus {
             background: rgb(var(--surface-1)) !important;
          }

          /* ===================================================
              CHECKBOX
            =================================================== */

            .manage-store-multiselect-panel .p-checkbox {
              width: 18px;
              height: 18px;
            }

            /* checkbox box */

            .manage-store-multiselect-panel
              .p-checkbox
              .p-checkbox-box {
              width: 18px;
              height: 18px;

              border-radius: 6px;

              border: 1px solid rgb(var(--border-primary));

              background: rgb(var(--surface-1));

              transition: all 0.2s ease;

              box-shadow: none !important;

              display: flex;
              align-items: center;
              justify-content: center;
            }

            /* hover */

            .manage-store-multiselect-panel
              .p-checkbox:not(.p-checkbox-disabled)
              .p-checkbox-box:hover {
              border-color: rgba(var(--color-gold-1), 0.5);
            }

            /* selected */

            .manage-store-multiselect-panel
              .p-checkbox
              .p-checkbox-box.p-highlight {
              background: rgb(var(--color-gold-1)) !important;

              border-color: rgb(var(--color-gold-1)) !important;
            }

            /* FIXED CHECK ICON */

            .manage-store-multiselect-panel
              .p-checkbox
              .p-checkbox-box
              .p-checkbox-icon {
              color: #111111 !important;

              stroke: #111111 !important;

              fill: #111111 !important;

              width: 12px !important;
              height: 12px !important;

              font-size: 12px !important;

              opacity: 1 !important;
            }

            /* dark mode */

            .dark
              .manage-store-multiselect-panel
              .p-checkbox
              .p-checkbox-box
              .p-checkbox-icon {
              color: #ffffff !important;

              stroke: #ffffff !important;

              fill: #ffffff !important;
            }

            /* focus */

            .manage-store-multiselect-panel
              .p-checkbox:not(.p-checkbox-disabled)
              .p-checkbox-box.p-focus {
              border-color: rgba(var(--color-gold-1), 0.45);

              box-shadow:
                0 0 0 3px rgba(var(--color-gold-1), 0.12) !important;
            }

          /* ===================================================
             SCROLLBAR
          =================================================== */

          .manage-store-multiselect-panel
            .p-multiselect-items-wrapper::-webkit-scrollbar {
            width: 6px;
          }

          .manage-store-multiselect-panel
            .p-multiselect-items-wrapper::-webkit-scrollbar-thumb {
            background:
              rgba(var(--color-gold-1), 0.35);

            border-radius: 20px;
          }

          /* ===================================================
             DARK MODE ENHANCEMENT
          =================================================== */

          .dark .manage-store-multiselect-panel {
            background:
              rgb(var(--surface-1)) !important;
          }

          .dark .manage-store-multiselect-panel
            .p-multiselect-item:hover {
            background:
              rgba(var(--color-gold-1), 0.12);
          }

          .p-multiselect-label-container {
             display: flex !important;
             align-items: center !important;
          }
        `}
      </style>
    </div>
  );
}